module.exports = __webpack_public_path__ + "img/yem.b5840a84.svg";